import { useMemo } from 'react';

const useFilteredAddresses = (doctorIds: number | number[], schedules: any[], addresses: any[]): any[] => {
  const matchedAddresses = useMemo(() => {
    // Ensure doctorIds is an array
    const doctorIdArray = Array.isArray(doctorIds) ? doctorIds : [doctorIds];

    // Filter schedules to find those matching any of the given doctorIds
    const filteredSchedules = schedules.filter(schedule => {
      const scheduleDoctorIds = Array.isArray(schedule.sch_doctor_ids)
        ? schedule.sch_doctor_ids.filter((id: string) => id !== "").map(Number)
        : [Number(schedule.sch_doctor_ids)];
      return scheduleDoctorIds.some((id: number) => doctorIdArray.includes(id));
    });

    // Extract unique address IDs from filtered schedules
    const uniqueAddressIds = Array.from(new Set(filteredSchedules.map(schedule => schedule.address_id)));
    const matchedAddresses = addresses.filter(address => uniqueAddressIds.includes(address.id));

    return matchedAddresses;
  }, [doctorIds, schedules, addresses]);

  return matchedAddresses;
};

export default useFilteredAddresses;
